import React from 'react'
import createCreateWorkByWizardRoutes from '@App/routes/rightsholder/creatework/wizard'
import createCreateWorkByFormRoutes from '@App/routes/rightsholder/creatework/form'
import createCreateWorkByBulkRoutes from '@App/routes/rightsholder/creatework/bulk'
import Navigation from '@App/navigation'
import RedirectToRightsholderSummary from '@Components/RedirectToRightsholderSummary'
import { Outlet } from 'react-router'
import { PERMISSIONS } from '@Const/permissions'
import PermissionCheck from '@Components/Utility/PermissionCheck'
import CreateWorkByWizardLayout from '@Scenes/WorkScenes/CreateWorkByWizardLayout'
import { CREATE_WORK_ROUTE, MANUAL_ROUTE } from '@App/navigation/route'

const createCreateWorkRoutes = () => {
    const createWorkByWizardRoutes = createCreateWorkByWizardRoutes()
    const createWorkByFormRoutes = createCreateWorkByFormRoutes()
    const createWorkByBulkRoutes = createCreateWorkByBulkRoutes()

    return {
        path: CREATE_WORK_ROUTE,
        element: (
            <PermissionCheck
                requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.manage_works]}
                orIsInternal
                reRouteLocation={Navigation.home.root()}
            >
                <Outlet />
            </PermissionCheck>
        ),
        children: [
            {
                path: '',
                element: <RedirectToRightsholderSummary />,
            },
            {
                path: MANUAL_ROUTE,
                element: <CreateWorkByWizardLayout />,
            },
            createWorkByWizardRoutes,
            createWorkByFormRoutes,
            createWorkByBulkRoutes,
        ],
    }
}

export default createCreateWorkRoutes
